import {
  Box,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { EventDetailTicketSalesSection } from "@common/interfaces/KYDEvent";
import { useEventMetrics } from "../hooks/useEventMetrics";
import { TicketSalesChart } from "./TicketSalesChart";

interface Props {
  label: string;
  value: string;
  height?: string;
}

export const Stat = ({ label, value, ...boxProps }) => {
  const headerSize = useBreakpointValue({ base: "sm", md: "md" });
  return (
    <Box
      key={label}
      px={{ base: "4", md: "4" }}
      py={{ base: "4", md: "3" }}
      bg="bg-surface"
      borderRadius="lg"
      borderWidth={"1px"}
      borderColor="gray.200"
      {...boxProps}
    >
      <Stack>
        <Text fontSize="sm" color="muted">
          {label}
        </Text>
        <Heading size={headerSize}>{value}</Heading>
      </Stack>
    </Box>
  );
};

const TicketSalesSection = ({
  isLoading,
  data,
}: {
  isLoading?: boolean;
  data: EventDetailTicketSalesSection["data"];
}) => {
  const { metrics, loading: isLoadingMetrics } = useEventMetrics(data.id);
  const isDraftEvent = data.status === "DRAFT";
  return (
    <>
      {!isDraftEvent ? (
        <Stack w="100%" align={"flex-end"}>
          <SimpleGrid w="100%" columns={{ base: 1, md: 4 }} gap="6">
            {metrics?.stats &&
              metrics.stats.map((stat) => (
                <Stat
                  key={stat.title}
                  label={stat.title}
                  value={stat.value}
                  height="80px"
                />
              ))}
          </SimpleGrid>
        </Stack>
      ) : null}
      {!isDraftEvent ? (
        <TicketSalesChart
          data={metrics}
          isLoading={isLoading || isLoadingMetrics}
        />
      ) : null}
    </>
  );
};

export default TicketSalesSection;
